/**
 * Returns an object that can be passed to the metaInfo property of a component
 * for use with vue-meta (https://github.com/declandewet/vue-meta).
 * @param {object} options
 * @param {string} options.title
 * @param {string} options.description
 * @param {string} options.image
 * @param {string} options.url
 */
function getMetaInfoObject({ title, description: desc, image, url }) {
  const metaInfo = {
    meta: [],
    link: [],
  };
  if (title) {
    metaInfo.title = title;
    metaInfo.meta.push(
      { vmid: 'ogTitle', property: 'og:title', content: title },
      { vmid: 'twTitle', property: 'twitter:title', content: title },
    );
  }
  if (desc) {
    metaInfo.meta.push(
      {
        hid: 'description',
        vmid: 'description',
        name: 'description',
        content: desc,
      },
      { vmid: 'ogDescription', property: 'og:description', content: desc },
      { vmid: 'twDescription', property: 'twitter:description', content: desc },
    );
  }
  if (image) {
    metaInfo.meta.push(
      { vmid: 'ogImage', property: 'og:image', content: image },
      { vmid: 'twImage', property: 'twitter:image', content: image },
    );
  }
  if (url) {
    metaInfo.meta.push({ vmid: 'ogUrl', property: 'og:url', content: url });
    metaInfo.link.push({ vmid: 'canonical', rel: 'canonical', href: url });
  }
  return metaInfo;
}
export default getMetaInfoObject;
